export default "__VITE_ASSET__BB9EeD2h__"